import type { ReactNode } from 'react';
import { createContext, useContext, useState } from 'react';
import type { Params } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { useCurrentNavigationValues } from '../contents';
import { useShowDigitalPracticeInformation } from '../user-management/hooks/use-show-digital-practice-information';

type NotificationsContextType = {
  sessionDoneNotification: boolean;
  setSessionDoneNotification: (value: boolean) => void;
};

const NotificationsContext = createContext<
  NotificationsContextType | undefined
>(undefined);

export function useNotifications() {
  const context = useContext(NotificationsContext);
  if (!context) {
    return {
      sessionDoneNotification: false,
      setSessionDoneNotification: () => {
        console.warn(
          'NotificationsProvider not found, notification state cannot be updated'
        );
      },
    };
  }
  return context;
}

type NotificationsProviderProps = {
  children: ReactNode;
};

export function NotificationsProvider({
  children,
}: NotificationsProviderProps) {
  const [sessionDoneNotification, setInternalSessionDoneNotification] =
    useState(false);
  const { courseOrder } = useCurrentNavigationValues();
  const { classroomId } = useParams<Params>();

  const { showDigitalPracticeNotificationAndLink } =
    useShowDigitalPracticeInformation({
      courseOrder,
      classroomId,
    });

  const setSessionDoneNotification = (value: boolean) => {
    if (showDigitalPracticeNotificationAndLink) {
      setInternalSessionDoneNotification(value);
    }
  };

  const value = {
    sessionDoneNotification,
    setSessionDoneNotification,
  };

  return (
    <NotificationsContext.Provider value={value}>
      {children}
    </NotificationsContext.Provider>
  );
}
